import { useGT } from 'gt-react';
import { Button } from '@/components/ui/button';

interface NamiSuggestionChipsProps {
  suggestions: readonly string[];
  onSelect: (text: string) => void;
  disabled?: boolean;
}

/**
 * Opening prompts a page offers while the thread is empty. Each chip sends its
 * text as the user's message through the same path as typing it.
 */
export function NamiSuggestionChips({
  suggestions,
  onSelect,
  disabled = false,
}: NamiSuggestionChipsProps) {
  const gt = useGT();
  if (suggestions.length === 0) return null;
  return (
    <div
      role="group"
      aria-label={gt('Suggestions', {
        context:
          'accessible name of the group of suggested prompts in the AI assistant panel',
      })}
      className="mb-2 flex flex-wrap gap-1.5"
    >
      {suggestions.map((text) => (
        <Button
          key={text}
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled}
          onClick={() => onSelect(text)}
          className="h-7 rounded-full px-2.5 text-xs font-normal"
        >
          {text}
        </Button>
      ))}
    </div>
  );
}
